export class PasswordChangeRequest {
    oldPassword: string = '';
    newPassword: string = '';
}